'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _common_1 = require("./class/_common");
var _sp_menu_1 = require("./class/_sp-menu");
var _home_1 = require("./class/_home");
var _recruit_1 = require("./class/_recruit");
var _pride_1 = require("./class/_pride");
var _pager_1 = require("./class/_pager");
var _products_1 = require("./class/_products");
$(function () {
    // 共通
    new _common_1.default.MyCommon();
    new _sp_menu_1.default.MySpMenu();
    new _home_1.default.MyHome();
    new _recruit_1.default.MyRecruit();
    new _pride_1.default.MyPride();
    new _pager_1.default.MyPager();
    new _products_1.default.MyProducts();
});
